import { useState, useRef, useEffect } from 'react';
import { FiMenu, FiX } from 'react-icons/fi';
import { FaUserCircle } from "react-icons/fa";
import { Link, useLocation } from 'react-router-dom';
import Logo from '../assets/Slide 4_3 - 24.svg';
import Logout from '../login/Logout';
import { NAV_CONFIG } from "./NavConfig";
// import { NavButton } from './NavButton';
import { useNavigate } from "react-router-dom";
import { getUserRole, isAuthenticated } from '../utils/auth';

const Nav = () => {
    const location = useLocation()
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);

    const user = getUserRole() || "guest";
    const isLoggedIn = isAuthenticated();

    const toggleDropdown = () => { setShowDropdown(!showDropdown) };
    const dropdownRef = useRef(null);
    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    return (
        <>
            <header className="border-b border-gray-300 py-1 sticky self-start" style={{
                top: 0,
                left: 0,
                right: 0,
                background: '#ffffff',
                zIndex: 1,
                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
            }}>
                <div className="flex justify-between items-center mx-5 max-w-full px-1 flex-wrap">
                    <Link to="/">
                        <div className="flex justify-center">
                            <img src={Logo} alt="logo" className="cursor-pointer mr-4" />
                        </div>
                    </Link>

                    <div className="lg:hidden block cursor-pointer" onClick={() => setOpen(!open)}>
                        {open ? <FiX className="h-8 w-8" /> : <FiMenu className="h-6 w-6" />}
                    </div>

                    <nav className={`${open ? 'block' : 'hidden'} lg:flex lg:items-center lg:w-auto w-full`}>
                        <ul className="text-base text-gray-700 lg:flex lg:justify-between">
                            {NAV_CONFIG
                                .filter((navItemConfig) => navItemConfig.roles.includes(user.role || "guest")) // Filter based on role
                                .map((navItemConfig) => (
                                    <li key={navItemConfig.keyIndex}
                                        className={`lg:px-5 py-2 hover:text-blue-500 font-semibold ${location.pathname === navItemConfig.pathname ? 'text-green-700' : ''
                                            }`}
                                    >
                                        <Link to={navItemConfig.pathname}>{navItemConfig.label}</Link>
                                    </li>
                                ))}
                            {isLoggedIn ? "" :
                                <button className="px-6 py-2 mr-4 text-xl hover:bg-slate-200 border border-blue-800 hover:border-gray-300 hover:text-gray-900 bg-blue-700 text-white rounded-full font-bold shadow-[0_0_20px_rgba(0,0,0,0.48)] duration-300" onClick={() => navigate('/login')}>
                                    Login
                                </button> 
                                }

                            <div className="relative">
                                <Link className="mt-1" to="#" onClick={toggleDropdown}>
                                    <FaUserCircle size={32} />
                                </Link>

                                {showDropdown && (
                                    <div
                                        ref={dropdownRef}
                                        className="absolute top-full right-0 min-w-[250px] w-64 z-10 bg-white text-black px-2 py-2 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                                    >
                                        <div><Logout /></div>
                                    </div>
                                )}
                            </div>
                        </ul>
                    </nav>
                </div>
            </header>
        </>
    );
};

export default Nav;
